function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.4751 11.8986H1.86876C1.5249 11.8986 1.24585 11.6568 1.24585 11.3588V1.64119C1.24585 1.34318 1.52493 1.10133 1.86876 1.10133H7.4751C7.81957 1.10133 8.09801 0.860022 8.09801 0.56148C8.09801 0.262938 7.81957 0.0215759 7.4751 0.0215759H1.86876C0.838447 0.0215759 0 0.748253 0 1.64119V11.3588C0 12.2517 0.838447 12.9783 1.86876 12.9783H7.4751C7.81957 12.9783 8.09801 12.737 8.09801 12.4385C8.09801 12.1399 7.81957 11.8986 7.4751 11.8986Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.8146 6.11557L11.0272 2.87636C10.783 2.66688 10.3881 2.6696 10.1464 2.88176C9.90473 3.09393 9.90722 3.43566 10.1527 3.64513L12.8593 5.96007H5.60655C5.26208 5.96007 4.98364 6.20139 4.98364 6.49993C4.98364 6.79847 5.26208 7.03981 5.60655 7.03981H12.8593L10.1527 9.35475C9.90725 9.56422 9.90537 9.90595 10.1464 10.1181C10.2685 10.225 10.4292 10.279 10.59 10.279C10.7482 10.279 10.9064 10.2272 11.0272 10.1235L14.8146 6.88429C14.933 6.78281 15.0002 6.64458 15.0002 6.4999C15.0002 6.35528 14.9336 6.21761 14.8146 6.11557Z",
  fill: "current"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 13,
  fill: "white"
})));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logout.690b3d6b.svg";
export { ForwardRef as ReactComponent };